import { createTaskService } from 'owa-todo-service';
import type { Todo } from 'owa-todo-types';
import type { CustomData } from 'owa-analytics-types';

/**
 * Handles creating multiple todos.
 * We need this because the REST API doesn't support creating multiple tasks in a single request.
 * This method returns after all the create calls are done.
 *
 * @param todos The todos to create
 * @param folderId The folder id in which to create the todos. If null, todos are created in default folder.
 */
type TodoResponseItem = Todo | null;
export default function handleCreateTodos(
    todos: Todo[],
    folderId: string,
    telemetryData: CustomData
): Promise<TodoResponseItem[]> {
    const createPromises: Promise<TodoResponseItem>[] = [];

    todos.forEach(todo => {
        createPromises.push(createTaskService(todo, folderId, telemetryData));
    });
    return Promise.all(createPromises);
}
